<p-table
  #shareTable
  [value]="data | async"
  [sortField]="sortField"
  [sortOrder]="sortOrder"
  [lazy]="true"
  [scrollable]="true"
  [paginator]="true"
  [rowsPerPageOptions]="[5, 50, 100, 200]"
  [showCurrentPageReport]="!metaData.loading"
  [rows]="metaData.rows"
  [totalRecords]="metaData.totalRecords || 0"
  [contextMenu]="enableContextMenu === true ? cm : null"
  [resizableColumns]="true"
  (onRowSelect)="onRowSelect($event)"
  (onLazyLoad)="loadDataLazy($event)"
  (onContextMenu)="onContextMenu($event)"
  (onContextMenuSelect)="onContextMenuSelect($event)"
  (onRowUnselect)="onRowUnselect($event)"
  [(selection)]="selectedRow"
  [(contextMenuSelection)]="selectedRowCM"
  scrollDirection="both"
  scrollHeight="55vh"
  selectionMode="single"
  responsiveLayout="scroll"
  scrollDirection="both"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  class="z-0"
>
  <ng-template pTemplate="caption">
    <!-- Toolbar row -->
    <div class="flex align-items-center gap-2 flex-wrap">
      <button
        pButton
        label="Clear"
        class="p-button-outlined p-button-sm"
        icon="pi pi-filter-slash"
        (click)="clearTableFilters(shareTable)"
      ></button>

      <button
        pButton
        [label]="filterBuilderVisible ? 'Hide filters' : 'Add filter'"
        [icon]="filterBuilderVisible ? 'pi pi-times' : 'pi pi-filter'"
        class="p-button-outlined p-button-sm"
        [class.p-button-primary]="filterBuilderVisible"
        (click)="filterBuilderVisible = !filterBuilderVisible"
      ></button>

      <ng-container *ngIf="enableDownloads && downloadEndpoint">
        <button
          *ngFor="let fmt of downloadFormats"
          pButton
          [label]="'Export ' + fmt.toUpperCase()"
          icon="pi pi-download"
          class="p-button-outlined p-button-sm p-button-success"
          [loading]="downloading"
          (click)="downloadAs(fmt)"
          [pTooltip]="'Download current filters as ' + fmt.toUpperCase()"
        ></button>
      </ng-container>

      <p-multiSelect
        [options]="columns"
        optionLabel="header"
        optionValue="field"
        [(ngModel)]="visibleColumns"
        [maxSelectedLabels]="2"
        [selectedItemsLabel]="'{0} columns selected'"
        [autoZIndex]="true"
        appendTo="body"
        (onChange)="onVisibleColumnsChange($event)"
        styleClass="p-inputtext-sm"
      ></p-multiSelect>

      <span class="p-input-icon-left ml-auto">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          name="globalFilter"
          [(ngModel)]="globalFilterValue"
          (input)="shareTable.filterGlobal(getFilterInputValue($event), 'contains')"
          placeholder="Search keyword"
          class="p-inputtext-sm"
        />
      </span>
    </div>

    <!-- Filter builder -->
    <div *ngIf="filterBuilderVisible" class="flex align-items-center gap-2 mt-2 flex-wrap">
      <p-dropdown
        [options]="columns"
        optionLabel="header"
        optionValue="field"
        [(ngModel)]="pendingField"
        placeholder="Field"
        appendTo="body"
        styleClass="p-inputtext-sm"
        style="min-width: 10rem"
      ></p-dropdown>

      <p-dropdown
        [options]="operatorOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="pendingOperator"
        appendTo="body"
        styleClass="p-inputtext-sm"
        style="min-width: 10rem"
      ></p-dropdown>

      <input
        pInputText
        [(ngModel)]="pendingValue"
        placeholder="Value"
        class="p-inputtext-sm"
        style="min-width: 10rem"
        (keydown.enter)="addFilter()"
      />

      <button
        pButton
        label="Add"
        icon="pi pi-plus"
        class="p-button-sm"
        [disabled]="!pendingField || !pendingValue.trim()"
        (click)="addFilter()"
      ></button>
    </div>

    <!-- Active filter chips -->
    <div
      *ngIf="activeFilters.length > 0 || globalFilterValue"
      class="flex align-items-center gap-2 mt-2 flex-wrap"
    >
      <span class="text-600 text-sm font-medium">Filters:</span>
      <p-selectButton
        *ngIf="activeFilters.length > 1"
        [options]="logicOptions"
        [(ngModel)]="filterLogic"
        (onChange)="onFilterLogicChange()"
        optionLabel="label"
        optionValue="value"
        styleClass="p-selectbutton-sm"
      ></p-selectButton>
      <span
        *ngFor="let f of activeFilters; let i = index"
        class="p-chip p-component text-sm"
        style="display: inline-flex; align-items: center"
      >
        <span class="p-chip-text"
          ><strong>{{ f.fieldLabel }}</strong
          >&nbsp;{{ f.operatorLabel.toLowerCase() }} '{{ f.value }}'</span
        >
        <span
          class="pi pi-times-circle pi-chip-remove-icon"
          tabindex="0"
          role="button"
          (click)="removeFilter(i)"
          (keydown.enter)="removeFilter(i)"
        ></span>
      </span>
      <span
        *ngIf="globalFilterValue"
        class="p-chip p-component text-sm"
        style="display: inline-flex; align-items: center"
      >
        <span class="p-chip-text">Search containing '{{ globalFilterValue }}'</span>
        <span
          class="pi pi-times-circle pi-chip-remove-icon"
          tabindex="0"
          role="button"
          (click)="clearGlobalFilter()"
          (keydown.enter)="clearGlobalFilter()"
        ></span>
      </span>
    </div>

    <!-- Query param context chip -->
    <div *ngIf="queryParams" class="mt-2">
      <p-chip
        label="ID: {{ queryParams }}"
        icon="pi pi-link"
        styleClass="text-sm p-chip-info"
      ></p-chip>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <!-- Responsive action column for small screens - moved to start -->
      <th *ngIf="isSmallScreen && enableContextMenu" class="action-column">
        <div class="flex align-items-center justify-content-center">Actions</div>
      </th>

      <th
        *ngFor="let col of columns"
        [hidden]="!visibleColumns.includes(col.field)"
        [pSortableColumn]="col.field"
        [pSortableColumnDisabled]="col.sortable === false"
      >
        <div class="flex align-items-center">
          {{ col.header }}
          <p-columnFilter
            *ngIf="col.filterable !== false"
            type="text"
            [field]="col.field"
            display="menu"
          ></p-columnFilter>
          <p-sortIcon *ngIf="col.sortable !== false" [field]="col.field"></p-sortIcon>
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-entity>
    <tr [pSelectableRow]="entity" [pContextMenuRow]="entity">
      <!-- Responsive action column cell for small screens - moved to start -->
      <td *ngIf="isSmallScreen && enableContextMenu" class="action-column">
        <div class="flex align-items-center justify-content-center">
          <button
            pButton
            icon="pi pi-ellipsis-v"
            class="p-button-rounded p-button-text p-button-sm"
            (click)="onActionButtonClick($event, entity)"
            pTooltip="Show actions"
            aria-label="Show actions"
          ></button>
        </div>
      </td>

      <td
        *ngFor="let col of columns"
        [hidden]="!visibleColumns.includes(col.field)"
        class="white-space-nowrap"
      >
        <ng-container *ngIf="getNestedValue(entity, col.field) as result">
          <ng-container *ngIf="col.formatter; else defaultRendering">
            <p-tag
              *ngIf="col.formatter(entity).tag"
              [value]="col.formatter(entity).tag!.value"
              [severity]="col.formatter(entity).tag!.severity"
              class="mb-1 mr-2"
            >
            </p-tag>
            <div class="text-900 font-medium">
              {{ col.formatter(entity).primary }}
            </div>

            <div *ngIf="col.formatter(entity).secondary" class="text-600 text-xs mt-1">
              <i
                *ngIf="col.formatter(entity).icon"
                class="pi {{ col.formatter(entity).icon }} mr-2"
              ></i
              >{{ col.formatter(entity).secondary }}
            </div>
            <div *ngIf="col.formatter(entity).tags?.length" class="flex flex-wrap gap-1 mt-1">
              <p-tag
                *ngFor="let chip of col.formatter(entity).tags"
                [value]="chip.value"
                [severity]="chip.severity || 'secondary'"
                [rounded]="true"
                [pTooltip]="chip.tooltip || ''"
                tooltipPosition="top"
                [styleClass]="chip.route ? 'text-xs cursor-pointer' : 'text-xs'"
                (click)="onChipClick($event, chip.route)"
              ></p-tag>
            </div>
          </ng-container>

          <ng-template #defaultRendering>
            <ng-container *ngIf="result.nested; else notnested">
              <ng-container *ngIf="result.plural; else singleObject">
                <ng-container *ngIf="result.items.length; else noRelatedEntity">
                  <ng-container *ngFor="let item of result.items">
                    <!-- {{ item | json }} -->

                    <button
                      (click)="onNestedObjectClick(item, col.field)"
                      pButton
                      pTooltip="Navigate to related entity"
                      class="p-button p-button-rounded"
                      [label]="getPluralNestedField(item)"
                    ></button>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #singleObject>
                <button
                  *ngIf="result.value; else noRelatedEntity"
                  (click)="onNestedObjectClick(entity, col.field)"
                  pButton
                  pTooltip="Navigate to related entity"
                  class="p-button p-button-link"
                  [label]="result.value"
                ></button>
              </ng-template>
              <ng-template #noRelatedEntity>
                <span class="text-500">N/A</span>
              </ng-template>
            </ng-container>
            <ng-template #notnested>
              <span *ngIf="result.type === 'date'">{{ result.value | date: 'dd MMM yyyy' }}</span>
              <span *ngIf="result.type === 'datetime'">{{
                result.value | date: 'dd MMM yyyy HH:mm'
              }}</span>
              <span *ngIf="result.type === 'number' && col.field !== 'amount_incl' && col.type !== 'currency'">{{
                result.value | number
              }}</span>
              <span *ngIf="col.type === 'currency' && result.value !== null && result.value !== undefined">{{
                result.value | currency: (entity.currency || 'ZAR') : 'symbol-narrow'
              }}</span>
              <span
                *ngIf="result.type === 'boolean' && col.field !== 'active'"
                class="badge status-{{ result.value ? 'true' : 'false' }}"
              >
                {{ result.value ? 'TRUE' : 'FALSE' }}
              </span>
              <span *ngIf="col.field === 'toc_status'" class="badge status-{{ result.value }}">
                {{ result.value }}
              </span>

              <span
                class="text-red-500"
                *ngIf="
                  col.field === 'amount_incl' &&
                  entity.transaction_type === 'debit' &&
                  col.header === 'Debit'
                "
                >{{ result.value | currency: 'R' }}</span
              >

              <span
                class="text-green-500"
                *ngIf="
                  col.field === 'amount_incl' &&
                  entity.transaction_type === 'credit' &&
                  col.header === 'Credit'
                "
                >{{ result.value | currency: 'ZAR' : 'symbol-narrow' }}</span
              >

              <button
                *ngIf="
                  col.field == 'action' &&
                  entity.transaction_type === 'credit' &&
                  entity.status === 'pending' &&
                  showAction
                "
                pButton
                pRipple
                label="Pay"
                class="p-button-rounded p-button-success p-button-sm"
                (click)="onPaymentDialog(entity)"
              ></button>
              <span
                *ngIf="
                  result.type === 'string' &&
                  col.field !== 'toc_status' &&
                  col.field !== 'toc_type' &&
                  col.field !== 'toc_sequence' &&
                  col.field !== 'toc_file_reference' &&
                  col.field !== 'physical_status' &&
                  col.field !== 'device_physical_status' &&
                  col.field !== 'subscription_status' &&
                  col.field !== 'account_status' &&
                  col.field !== 'active' &&
                  col.field !== 'service_status' &&
                  col.field !== 'status' &&
                  col.field !== 'amount_incl' &&
                  col.field !== 'amount_excl' &&
                  col.field !== 'action'
                "
                >{{ result.value }}</span
              >

              <div
                *ngIf="col.field === 'physical_status' || col.field === 'device_physical_status'"
                class="text-center text-{{ getDevicePhysicalStatusColor(entity) }}-500 "
              >
                <span class="text-center pi {{ getDevicePhysicalStatus(entity) }} text-2xl"></span>
              </div>
              <ng-container *ngIf="col.field === 'toc_file_reference'">
                <button
                  (click)="downloadFile(entity['toc_file_reference'])"
                  pButton
                  icon="pi pi-download"
                  class="p-button p-button-link"
                  [label]="entity['toc_file_reference']"
                ></button>
              </ng-container>
              <ng-container *ngIf="col.field === 'subscription_status'">
                <p-tag
                  [value]="result.value | anyAsStatusString | uppercase"
                  [severity]="getSubscriptionSeverity(result.value)"
                ></p-tag>
              </ng-container>
              <ng-container class="flex align-items-center" *ngIf="col.field === 'account_status'">
                <p-tag
                  [value]="result.value | anyAsStatusString | uppercase"
                  [severity]="getAccountSeverity(result.value)"
                ></p-tag>
              </ng-container>
              <ng-container *ngIf="col.field === 'active'">
                <p-tag
                  [value]="result.value ? 'TRUE' : 'FALSE'"
                  [severity]="result.value ? 'success' : 'danger'"
                ></p-tag>
              </ng-container>

              <ng-container *ngIf="col.field === 'service_status'">
                <p-tag
                  [value]="result.value | uppercase"
                  [severity]="getServiceSeverity(result.value)"
                ></p-tag>
              </ng-container>
              <ng-container *ngIf="col.field === 'status'">
                <p-tag
                  [value]="result.value | uppercase"
                  [severity]="getTransactionStatusSeverity(result.value)"
                ></p-tag>
              </ng-container>
              <ng-container *ngIf="col.field === 'toc_type'">
                <p-tag [value]="result.value | uppercase" [style]="tocTypeTagStyle(result.value)"></p-tag>
              </ng-container>
              <ng-container *ngIf="col.field === 'toc_sequence'">
                <p-tag
                  [value]="(result.value || TOC_SEQUENCE_DEFAULT) | uppercase"
                  [style]="tocSequenceTagStyle"
                ></p-tag>
              </ng-container>
            </ng-template>
          </ng-template>
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <ng-container *ngIf="metaData.loading">
      <tr>
        <td
          [attr.colspan]="getNumberOfColumns() + (isSmallScreen && enableContextMenu ? 1 : 0)"
          class="align-content-center"
        >
          <p-progressBar
            styleClass="align-self-center"
            *ngIf="metaData.loading"
            mode="indeterminate"
          >
          </p-progressBar>
        </td>
      </tr>
      <tr *ngFor="let number of loadingRowsNumbers">
        <td *ngIf="isSmallScreen && enableContextMenu">
          <p-skeleton [ngStyle]="{ width: '8vw', height: '4vh' }"></p-skeleton>
        </td>
        <td *ngFor="let col of visibleColumns; let even = even">
          <p-skeleton [ngStyle]="{ width: '10vw', height: '4vh' }"></p-skeleton>
        </td>
      </tr>
    </ng-container>

    <ng-container *ngIf="!metaData.loading">
      <tr>
        <td
          [attr.colspan]="getNumberOfColumns() + (isSmallScreen && enableContextMenu ? 1 : 0)"
          class="text-center"
        >
          <share-empty-state></share-empty-state>
        </td>
      </tr>
    </ng-container>
  </ng-template>
</p-table>
<p-contextMenu #cm [model]="this.menuItems" appendTo="body"></p-contextMenu>
